import { useState } from "react";
import { MapPin, CalendarDays, DollarSign, Hand, Check, Loader2, Phone, Navigation, User } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export function JobCard({ job, onChange }) {
  const [busy, setBusy] = useState(false);
  const [note, setNote] = useState("");
  const [asking, setAsking] = useState(false);

  const raise = async () => {
    setBusy(true);
    try { const r = await api.post(`/tech/jobs/${job.job_id}/interest`, { note }); onChange(r.data); toast.success("Hand raised — David will confirm"); setAsking(false); }
    catch (e) { toast.error(e?.response?.data?.detail || "Couldn't raise your hand"); }
    finally { setBusy(false); }
  };
  const withdraw = async () => {
    setBusy(true);
    try { const r = await api.delete(`/tech/jobs/${job.job_id}/interest`); onChange(r.data); toast.success("Withdrawn"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Couldn't withdraw"); }
    finally { setBusy(false); }
  };

  const c = job.customer;
  return (
    <div className={`dg-card rounded-2xl p-5 ${job.mine ? "border-emerald-500/40" : ""}`} data-testid={`job-card-${job.job_id}`}>
      <div className="flex items-start justify-between gap-3">
        <h3 className="font-display text-lg font-bold" data-testid={`job-title-${job.job_id}`}>{job.title}</h3>
        {job.mine ? <span className="dg-chip text-emerald-300 shrink-0" data-testid={`job-chip-${job.job_id}`}>Yours</span>
          : job.taken ? <span className="dg-chip text-slate-500 shrink-0" data-testid={`job-chip-${job.job_id}`}>Taken</span>
          : job.interested ? <span className="dg-chip text-[#FFD600] shrink-0" data-testid={`job-chip-${job.job_id}`}>Hand raised</span>
          : <span className="dg-chip text-cyan-300 shrink-0" data-testid={`job-chip-${job.job_id}`}>Open</span>}
      </div>
      <div className="flex flex-wrap gap-x-4 gap-y-1 text-sm text-slate-300 mt-2">
        <span className="inline-flex items-center gap-1"><MapPin className="w-3.5 h-3.5 text-cyan-300" /> {job.area}</span>
        {job.date_window && <span className="inline-flex items-center gap-1"><CalendarDays className="w-3.5 h-3.5 text-cyan-300" /> {job.date_window}</span>}
        {job.pay_usd > 0 && <span className="inline-flex items-center gap-1 text-[#FFD600]"><DollarSign className="w-3.5 h-3.5" /> {Number(job.pay_usd).toFixed(2)}</span>}
      </div>
      {job.summary && <p className="text-sm text-slate-400 mt-3 whitespace-pre-wrap">{job.summary}</p>}

      {job.mine && c && (
        <div className="mt-4 rounded-xl border border-emerald-500/30 bg-emerald-500/10 p-4 text-sm space-y-1" data-testid={`job-customer-${job.job_id}`}>
          <div className="dg-eyebrow text-emerald-300">Customer</div>
          <div className="flex items-center gap-2"><User className="w-4 h-4" /> {c.name || "—"}</div>
          {c.phone && <a href={`tel:${c.phone}`} className="flex items-center gap-2 dg-link"><Phone className="w-4 h-4" /> {c.phone}</a>}
          {c.address && <a href={`https://maps.google.com/?q=${encodeURIComponent(c.address)}`} target="_blank" rel="noreferrer" className="flex items-center gap-2 dg-link"><Navigation className="w-4 h-4" /> {c.address}</a>}
        </div>
      )}

      {!job.mine && !job.taken && (
        <div className="mt-4">
          {job.interested ? (
            <button type="button" onClick={withdraw} disabled={busy} className="dg-btn-ghost rounded-full px-4 py-2 text-sm inline-flex items-center gap-2 disabled:opacity-50" data-testid={`job-withdraw-${job.job_id}`}>
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Check className="w-4 h-4" />} Hand raised — withdraw
            </button>
          ) : asking ? (
            <div className="space-y-2">
              <input value={note} onChange={(e) => setNote(e.target.value)} maxLength={500} placeholder="Optional note for David (availability, questions)" className="dg-input w-full text-sm" data-testid={`job-note-${job.job_id}`} />
              <div className="flex gap-2">
                <button type="button" onClick={raise} disabled={busy} className="dg-btn-primary rounded-full px-5 py-2 text-sm inline-flex items-center gap-2 disabled:opacity-50" data-testid={`job-confirm-${job.job_id}`}>{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Hand className="w-4 h-4" />} Yes, I want this job</button>
                <button type="button" onClick={() => setAsking(false)} className="dg-btn-ghost rounded-full px-4 py-2 text-sm" data-testid={`job-cancel-${job.job_id}`}>Back</button>
              </div>
            </div>
          ) : (
            <button type="button" onClick={() => setAsking(true)} className="dg-btn-primary rounded-full px-5 py-2 text-sm inline-flex items-center gap-2" data-testid={`job-raise-${job.job_id}`}><Hand className="w-4 h-4" /> I'm interested</button>
          )}
        </div>
      )}
    </div>
  );
}
